import { defineComponent, inject, computed, openBlock, createElementBlock, normalizeClass, createCommentVNode, renderSlot, provide, reactive, toRef } from 'vue';
import { elFormKey, elFormItemKey, elButtonGroupKey } from '../../tokens';
import { useGlobalConfig } from '../../utils/util';
import { isValidComponentSize } from '../../utils/validators';

var script = defineComponent({
  name: "ElButton",
  props: {
    type: {
      type: String,
      default: "default",
      validator: (val) => {
        return [
          "default",
          "primary",
          "success",
          "warning",
          "info",
          "danger",
          "text"
        ].includes(val);
      }
    },
    size: {
      type: String,
      validator: isValidComponentSize
    },
    icon: {
      type: String,
      default: ""
    },
    nativeType: {
      type: String,
      default: "button",
      validator: (val) => {
        return ["button", "submit", "reset"].includes(val);
      }
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },
  emits: ["click"],
  setup(props, { emit }) {
    const $ELEMENT = useGlobalConfig();
    const elForm = inject(elFormKey, {});
    const elFormItem = inject(elFormItemKey, {});
    const elBtnGroup = inject(elButtonGroupKey, {});
    const buttonSize = computed(() => {
      return props.size || elBtnGroup.size || elFormItem.size || $ELEMENT.size;
    });
    const buttonDisabled = computed(() => {
      return props.disabled || elForm.disabled;
    });
    const handleClick = (evt) => {
      emit("click", evt);
    };
    return {
      buttonSize,
      buttonDisabled,
      handleClick
    };
  }
});

const _hoisted_1 = ["disabled", "autofocus", "type"];
const _hoisted_2 = {
  key: 0,
  class: "el-icon-loading"
};
const _hoisted_3 = { key: 2 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    class: normalizeClass([
      "el-button",
      _ctx.type ? "el-button--" + _ctx.type : "",
      _ctx.buttonSize ? "el-button--" + _ctx.buttonSize : "",
      {
        "is-disabled": _ctx.buttonDisabled,
        "is-loading": _ctx.loading,
        "is-plain": _ctx.plain,
        "is-round": _ctx.round,
        "is-circle": _ctx.circle
      }
    ]),
    disabled: _ctx.buttonDisabled || _ctx.loading,
    autofocus: _ctx.autofocus,
    type: _ctx.nativeType,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClick && _ctx.handleClick(...args))
  }, [
    _ctx.loading ? (openBlock(), createElementBlock("i", _hoisted_2)) : createCommentVNode("v-if", true),
    _ctx.icon && !_ctx.loading ? (openBlock(), createElementBlock("i", {
      key: 1,
      class: normalizeClass(_ctx.icon)
    }, null, 2)) : createCommentVNode("v-if", true),
    _ctx.$slots.default ? (openBlock(), createElementBlock("span", _hoisted_3, [
      renderSlot(_ctx.$slots, "default")
    ])) : createCommentVNode("v-if", true)
  ], 10, _hoisted_1);
}

script.render = render;
script.__file = "packages/components/button/src/button.vue";

var script$1 = defineComponent({
  name: "ElButtonGroup",
  props: {
    size: {
      type: String,
      validator: isValidComponentSize
    }
  },
  setup(props) {
    provide(elButtonGroupKey, reactive({
      size: toRef(props, "size")
    }));
  }
});

const _hoisted_1$1 = { class: "el-button-group" };
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}

script$1.render = render$1;
script$1.__file = "packages/components/button/src/button-group.vue";

script.install = (app) => {
  app.component(script.name, script);
  app.component(script$1.name, script$1);
};
script.ButtonGroup = script$1;
const _Button = script;
const ElButton = _Button;
const ElButtonGroup = script$1;

export default _Button;
export { ElButton, ElButtonGroup };
